import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/question'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(question) {
    return http.post(`${resource}`, question, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(question, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, question, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },

}
